export default __webpack_public_path__ + "static/media/hotei11.89c4d7e3.webp";